module.exports = __webpack_public_path__ + "media/images/right_show_sidebar/arrow-left-9d778c2e138b11ac023d18353f256810.png";